import React, { useEffect, useRef, useState } from "react";
import Input from "antd/es/input/Input";
import { Button, Typography, Select } from "antd";
import { useNavigate } from "react-router-dom";
import { GreenNotify, RedNotify, uploadMediaToS3 } from "../../helper/helper";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import Loader from "../loader/loader";
import { imagePlaceholder } from "../../assets";

const TICKER_TYPES = [
  { label: "Text", value: "text" },
  { label: "Image", value: "image" },
];

const NewTickerItem = () => {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const [type, setType] = useState("text");
  const [textValue, setTextValue] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [isloading, setIsLoading] = useState(false);

  useEffect(() => {
    return () => {
      if (imageUrl?.startsWith("blob:")) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [imageUrl]);

  const createTickerItem = async () => {
    if (type === "text") {
      if (!textValue?.trim()) {
        RedNotify("Please enter text content");
        return;
      }
    } else {
      if (!imageFile && !imageUrl) {
        RedNotify("Please select an image");
        return;
      }
    }

    let tickerValue = textValue.trim();

    if (type === "image") {
      try {
        if (imageFile) {
          setIsLoading(true);
          tickerValue = await uploadMediaToS3(imageFile, false);
          setImageUrl(tickerValue);
          setImageFile(null);
        } else {
          tickerValue = imageUrl;
        }
      } catch (error) {
        console.error("Error uploading ticker image", error);
        RedNotify("Image upload failed");
        setIsLoading(false);
        return;
      }
    }

    const body = {
      type,
      value: tickerValue,
    };

    const onSuccess = () => {
      GreenNotify("Ticker item created successfully");
      navigate("/ticker");
    };

    const onError = (err) => {
      console.log("Error creating ticker item", err);
      RedNotify("Failed to create ticker item");
    };

    callApi("POST", routes.createTickerItem, body, setIsLoading, onSuccess, onError);
  };

  const handleImageSelect = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      RedNotify("Please select an image file");
      e.target.value = "";
      return;
    }
    setImageFile(file);
    setImageUrl(URL.createObjectURL(file));
  };

  return (
    <>
      <div style={{ marginBottom: "2rem", padding: "3rem" }}>
        <Loader loading={isloading} />
        <h2>Add Ticker Item</h2>

        <Typography.Title level={5} style={{ marginTop: "2rem" }}>
          Type
        </Typography.Title>
        <Select
          value={type}
          onChange={(v) => {
            setType(v);
            setTextValue("");
            setImageUrl("");
            setImageFile(null);
            if (fileInputRef.current) {
              fileInputRef.current.value = "";
            }
          }}
          options={TICKER_TYPES}
          style={{ marginTop: "0.5rem", width: "100%", maxWidth: "20rem" }}
        />

        {type === "text" && (
          <>
            <Typography.Title level={5} style={{ marginTop: "2rem" }}>
              Text content
            </Typography.Title>
            <Input.TextArea
              value={textValue}
              onChange={(e) => setTextValue(e.target.value)}
              placeholder="Enter ticker text"
              style={{ marginTop: "0.5rem", minHeight: 100, width: "100%", maxWidth: "32rem" }}
              rows={3}
            />
          </>
        )}

        {type === "image" && (
          <>
            <Typography.Title level={5} style={{ marginTop: "2rem" }}>
              Image thumbnail
            </Typography.Title>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleImageSelect}
              style={{ display: "none" }}
            />
            <div style={{ marginTop: "0.5rem", display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
              <div
                onClick={() => fileInputRef.current?.click()}
                style={{
                  width: 80,
                  height: 80,
                  borderRadius: 8,
                  border: "1px dashed #d9d9d9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  overflow: "hidden",
                  background: "#fafafa",
                }}
              >
                {imageUrl ? (
                  <img src={imageUrl} alt="Preview" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                ) : (
                  <img src={imagePlaceholder} alt="Upload" style={{ width: 40, height: 40, opacity: 0.5 }} />
                )}
              </div>
            </div>
          </>
        )}

        <div style={{ marginTop: "2rem", display: "flex", gap: 12 }}>
          <Button type="primary" onClick={createTickerItem} loading={isloading}>
            Create
          </Button>
          <Button onClick={() => navigate("/ticker")}>Cancel</Button>
        </div>
      </div>
    </>
  );
};

export default NewTickerItem;
